import {createAction, props} from "@ngrx/store";

export const addCompany = createAction('[Company] Add Company', props<{ companies: string[] }>());
export const removeCompany = createAction('[Company] Remove Company', props<{ company: string }>());
export const removeAllCompanies = createAction('[Company] Remove All Companies');
